import React from "react";
import "./Business.scss";
import { desktopImages } from "../../images";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Business.scss";
const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 2.3, // Mostrar 2 logos e um pedaço da terceira
  slidesToScroll: 1,
  arrows: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: "unslick", // Desativar carrossel em telas maiores
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2.3,
        slidesToScroll: 1,
        margin: 0,
        variableWidth: true,
      },
    },
  ],
};
const Business = () => {
  return (
    <div id="Business">
      <div class="body-main">
        <div class="logo-group">
          <div class="img-test-bg"></div>
        </div>

        <div class="container-1">
          <div class="box-grupo pharma">
            <div class="intro">
              <h2 class="titulo">Suprimentos</h2>
              <h3 class="subtitulo">Bruna Santos Peters</h3>
            </div>
            <div class="Businesss">
              <div class="whats-div">
                <a
                  target="_blank"
                  href="https://api.whatsapp.com/send?phone=5548988150962"
                  class="whats"
                  rel="noreferrer"
                >
                  (48) 98815 0962
                </a>
                <a
                  target="_blank"
                  href="https://api.whatsapp.com/send?phone=5548988150962"
                  rel="noreferrer"
                >
                  <svg
                    id="Whats_App"
                    data-name="Whats App"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    width="18.583"
                    height="18.75"
                    viewBox="0 0 18.583 18.75"
                  >
                    <defs>
                      <clipPath id="clip-path">
                        <rect
                          id="Retângulo_1055"
                          data-name="Retângulo 1055"
                          width="18.583"
                          height="18.75"
                          fill="none"
                          stroke="#242222"
                          stroke-width="0.4"
                        />
                      </clipPath>
                    </defs>
                    <g
                      id="Grupo_1448"
                      data-name="Grupo 1448"
                      clip-path="url(#clip-path)"
                    >
                      <path
                        id="Caminho_735"
                        data-name="Caminho 735"
                        d="M13.737,11.209c-.228-.125-1.352-.732-1.562-.818s-.365-.13-.529.1-.63.735-.771.885-.278.165-.508.039a6.369,6.369,0,0,1-1.829-1.227A7.022,7.022,0,0,1,7.3,8.523c-.128-.238,0-.36.12-.472s.243-.264.365-.4a1.6,1.6,0,0,0,.247-.38.428.428,0,0,0,0-.409c-.054-.119-.476-1.284-.653-1.758S7,4.706,6.869,4.7s-.29-.03-.446-.036a.856.856,0,0,0-.632.268A2.614,2.614,0,0,0,4.9,6.847a4.535,4.535,0,0,0,.861,2.446,9.56,9.56,0,0,0,3.845,3.669c2.333,1.023,2.345.711,2.773.688A2.357,2.357,0,0,0,14,12.6a1.952,1.952,0,0,0,.177-1.1c-.055-.1-.208-.164-.436-.289M9.459,16.737A7.539,7.539,0,0,1,5.282,15.48l-2.919.936.949-2.824a7.589,7.589,0,1,1,6.147,3.146M9.459,0A9.137,9.137,0,0,0,1.647,13.85L0,18.75l5.05-1.619A9.131,9.131,0,1,0,9.459,0"
                        transform="translate(0 0)"
                        fill="#f1f2f2"
                        stroke="#242222"
                        stroke-width="0.4"
                        fill-rule="evenodd"
                      />
                    </g>
                  </svg>
                </a>
              </div>
              <a
                target="_blank"
                href="mailto:bruna.peters@essentialnutrition.com.br"
                class="mail"
                rel="noreferrer"
              >
                bruna.peters@essentialnutrition.com.br
              </a>
            </div>
          </div>
          <div class="box-grupo injetaveis">
            <div class="intro">
              <h2 class="titulo">P&D</h2>
              <h3 class="subtitulo">Tatyane Martins</h3>
            </div>
            <div class="Businesss">
              <div class="whats-div">
                <a
                  target="_blank"
                  href="https://api.whatsapp.com/send?phone=5548988590341"
                  class="whats"
                  rel="noreferrer"
                >
                  (48) 98859 0341
                </a>
                <a
                  target="_blank"
                  href="https://api.whatsapp.com/send?phone=5548988590341"
                  rel="noreferrer"
                >
                  <svg
                    id="Whats_App"
                    data-name="Whats App"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    width="18.583"
                    height="18.75"
                    viewBox="0 0 18.583 18.75"
                  >
                    <defs>
                      <clipPath id="clip-path">
                        <rect
                          id="Retângulo_1055"
                          data-name="Retângulo 1055"
                          width="18.583"
                          height="18.75"
                          fill="none"
                          stroke="#242222"
                          stroke-width="0.4"
                        />
                      </clipPath>
                    </defs>
                    <g
                      id="Grupo_1448"
                      data-name="Grupo 1448"
                      clip-path="url(#clip-path)"
                    >
                      <path
                        id="Caminho_735"
                        data-name="Caminho 735"
                        d="M13.737,11.209c-.228-.125-1.352-.732-1.562-.818s-.365-.13-.529.1-.63.735-.771.885-.278.165-.508.039a6.369,6.369,0,0,1-1.829-1.227A7.022,7.022,0,0,1,7.3,8.523c-.128-.238,0-.36.12-.472s.243-.264.365-.4a1.6,1.6,0,0,0,.247-.38.428.428,0,0,0,0-.409c-.054-.119-.476-1.284-.653-1.758S7,4.706,6.869,4.7s-.29-.03-.446-.036a.856.856,0,0,0-.632.268A2.614,2.614,0,0,0,4.9,6.847a4.535,4.535,0,0,0,.861,2.446,9.56,9.56,0,0,0,3.845,3.669c2.333,1.023,2.345.711,2.773.688A2.357,2.357,0,0,0,14,12.6a1.952,1.952,0,0,0,.177-1.1c-.055-.1-.208-.164-.436-.289M9.459,16.737A7.539,7.539,0,0,1,5.282,15.48l-2.919.936.949-2.824a7.589,7.589,0,1,1,6.147,3.146M9.459,0A9.137,9.137,0,0,0,1.647,13.85L0,18.75l5.05-1.619A9.131,9.131,0,1,0,9.459,0"
                        transform="translate(0 0)"
                        fill="#f1f2f2"
                        stroke="#242222"
                        stroke-width="0.4"
                        fill-rule="evenodd"
                      />
                    </g>
                  </svg>
                </a>
              </div>
              <a
                target="_blank"
                href="mailto:tatyane.martins@essentiagroup.com.br"
                class="mail"
                rel="noreferrer"
              >
                tatyane.martins@essentiagroup.com.br
              </a>
            </div>
          </div>
        </div>

        <div class="container-1">
          <div class="box-grupo pharma">
            <div class="intro">
              <h2 class="titulo">RH</h2>
              <h3 class="subtitulo">Faça parte do nosso time.</h3>
            </div>
            <div class="Businesss">
              <div class="whats-div">
                <a
                  target="_blank"
                  href="https://api.whatsapp.com/send?phone=5548991486935"
                  class="whats"
                  rel="noreferrer"
                >
                  (48) 99148 6935
                </a>
                <a
                  target="_blank"
                  href="https://api.whatsapp.com/send?phone=5548991486935"
                  rel="noreferrer"
                >
                  <svg
                    id="Whats_App"
                    data-name="Whats App"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    width="18.583"
                    height="18.75"
                    viewBox="0 0 18.583 18.75"
                  >
                    <defs>
                      <clipPath id="clip-path">
                        <rect
                          id="Retângulo_1055"
                          data-name="Retângulo 1055"
                          width="18.583"
                          height="18.75"
                          fill="none"
                          stroke="#242222"
                          stroke-width="0.4"
                        />
                      </clipPath>
                    </defs>
                    <g
                      id="Grupo_1448"
                      data-name="Grupo 1448"
                      clip-path="url(#clip-path)"
                    >
                      <path
                        id="Caminho_735"
                        data-name="Caminho 735"
                        d="M13.737,11.209c-.228-.125-1.352-.732-1.562-.818s-.365-.13-.529.1-.63.735-.771.885-.278.165-.508.039a6.369,6.369,0,0,1-1.829-1.227A7.022,7.022,0,0,1,7.3,8.523c-.128-.238,0-.36.12-.472s.243-.264.365-.4a1.6,1.6,0,0,0,.247-.38.428.428,0,0,0,0-.409c-.054-.119-.476-1.284-.653-1.758S7,4.706,6.869,4.7s-.29-.03-.446-.036a.856.856,0,0,0-.632.268A2.614,2.614,0,0,0,4.9,6.847a4.535,4.535,0,0,0,.861,2.446,9.56,9.56,0,0,0,3.845,3.669c2.333,1.023,2.345.711,2.773.688A2.357,2.357,0,0,0,14,12.6a1.952,1.952,0,0,0,.177-1.1c-.055-.1-.208-.164-.436-.289M9.459,16.737A7.539,7.539,0,0,1,5.282,15.48l-2.919.936.949-2.824a7.589,7.589,0,1,1,6.147,3.146M9.459,0A9.137,9.137,0,0,0,1.647,13.85L0,18.75l5.05-1.619A9.131,9.131,0,1,0,9.459,0"
                        transform="translate(0 0)"
                        fill="#f1f2f2"
                        stroke="#242222"
                        stroke-width="0.4"
                        fill-rule="evenodd"
                      />
                    </g>
                  </svg>
                </a>
              </div>
              <a
                target="_blank"
                href="https://essentiagroup.gupy.io"
                class="mail"
                rel="noreferrer"
              >
                https://essentiagroup.gupy.io
              </a>
            </div>
          </div>
          <div class="box-grupo nutrition">
            <div class="intro">
              <h2 class="titulo">Marketing</h2>
              <h3 class="subtitulo">Fale com o nosso time.</h3>
            </div>
            <div class="Businesss">
              <a
                target="_blank"
                href="mailto:marketing@essentiagroup.com.br "
                class="mail"
                rel="noreferrer"
              >
                marketing@essentiagroup.com.br
              </a>
            </div>
          </div>
        </div>
        <div class="container-1">
          <div class="box-grupo nutrition">
            <div class="intro">
              <h2 class="titulo">Parcerias</h2>
              <h3 class="subtitulo">Para atletas e influenciadores.</h3>
            </div>
            <div class="Businesss">
              <a
                target="_blank"
                href="https://web738966.typeform.com/to/ABpdwtHE"
                class="mail"
                rel="noreferrer"
              >
                https://web738966.typeform.com/to/ABpdwtHE
              </a>
            </div>
          </div>
          <div class="box-grupo nutrition">
            <div class="intro">
              <h2 class="titulo">Revenda</h2>
              <h3 class="subtitulo">Seja um revendedor credenciado.</h3>
            </div>
            <div class="Businesss">
              <div class="whats-div">
                <a
                  target="_blank"
                  href="https://api.whatsapp.com/send?phone=5548988076983"
                  class="whats"
                  rel="noreferrer"
                >
                  (48) 98807 6983
                </a>
                <a
                  target="_blank"
                  href="https://api.whatsapp.com/send?phone=5548988076983"
                  rel="noreferrer"
                >
                  <svg
                    id="Whats_App"
                    data-name="Whats App"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    width="18.583"
                    height="18.75"
                    viewBox="0 0 18.583 18.75"
                  >
                    <defs>
                      <clipPath id="clip-path">
                        <rect
                          id="Retângulo_1055"
                          data-name="Retângulo 1055"
                          width="18.583"
                          height="18.75"
                          fill="none"
                          stroke="#242222"
                          stroke-width="0.4"
                        />
                      </clipPath>
                    </defs>
                    <g
                      id="Grupo_1448"
                      data-name="Grupo 1448"
                      clip-path="url(#clip-path)"
                    >
                      <path
                        id="Caminho_735"
                        data-name="Caminho 735"
                        d="M13.737,11.209c-.228-.125-1.352-.732-1.562-.818s-.365-.13-.529.1-.63.735-.771.885-.278.165-.508.039a6.369,6.369,0,0,1-1.829-1.227A7.022,7.022,0,0,1,7.3,8.523c-.128-.238,0-.36.12-.472s.243-.264.365-.4a1.6,1.6,0,0,0,.247-.38.428.428,0,0,0,0-.409c-.054-.119-.476-1.284-.653-1.758S7,4.706,6.869,4.7s-.29-.03-.446-.036a.856.856,0,0,0-.632.268A2.614,2.614,0,0,0,4.9,6.847a4.535,4.535,0,0,0,.861,2.446,9.56,9.56,0,0,0,3.845,3.669c2.333,1.023,2.345.711,2.773.688A2.357,2.357,0,0,0,14,12.6a1.952,1.952,0,0,0,.177-1.1c-.055-.1-.208-.164-.436-.289M9.459,16.737A7.539,7.539,0,0,1,5.282,15.48l-2.919.936.949-2.824a7.589,7.589,0,1,1,6.147,3.146M9.459,0A9.137,9.137,0,0,0,1.647,13.85L0,18.75l5.05-1.619A9.131,9.131,0,1,0,9.459,0"
                        transform="translate(0 0)"
                        fill="#f1f2f2"
                        stroke="#242222"
                        stroke-width="0.4"
                        fill-rule="evenodd"
                      />
                    </g>
                  </svg>
                </a>
              </div>
              <p target="_blank" href="" class="phone">
                0800 607 9030
              </p>
              <a
                target="_blank"
                href="mailto:revendas@essentialnutrition.com.br"
                class="mail"
                rel="noreferrer"
              >
                revendas@essentialnutrition.com.br
              </a>
            </div>
          </div>
        </div>
        <div class="container-1">
          <div class="box-grupo injetaveis">
            <div class="intro">
              <h2 class="titulo">Be Generous</h2>
              <h3 class="subtitulo">
                Saiba mais sobre o<br /> nosso projeto social.
              </h3>
            </div>
            <div class="Businesss">
              <p target="_blank" href="" class="phone"></p>
              <div class="whats-div">
                <a
                  target="_blank"
                  href="https://api.whatsapp.com/send?phone=5548988183492"
                  class="whats"
                  rel="noreferrer"
                >
                  (48) 98818 3492
                </a>
                <a
                  target="_blank"
                  href="https://api.whatsapp.com/send?phone=5548988183492"
                  rel="noreferrer"
                >
                  <svg
                    id="Whats_App"
                    data-name="Whats App"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    width="18.583"
                    height="18.75"
                    viewBox="0 0 18.583 18.75"
                  >
                    <defs>
                      <clipPath id="clip-path">
                        <rect
                          id="Retângulo_1055"
                          data-name="Retângulo 1055"
                          width="18.583"
                          height="18.75"
                          fill="none"
                          stroke="#242222"
                          stroke-width="0.4"
                        />
                      </clipPath>
                    </defs>
                    <g
                      id="Grupo_1448"
                      data-name="Grupo 1448"
                      clip-path="url(#clip-path)"
                    >
                      <path
                        id="Caminho_735"
                        data-name="Caminho 735"
                        d="M13.737,11.209c-.228-.125-1.352-.732-1.562-.818s-.365-.13-.529.1-.63.735-.771.885-.278.165-.508.039a6.369,6.369,0,0,1-1.829-1.227A7.022,7.022,0,0,1,7.3,8.523c-.128-.238,0-.36.12-.472s.243-.264.365-.4a1.6,1.6,0,0,0,.247-.38.428.428,0,0,0,0-.409c-.054-.119-.476-1.284-.653-1.758S7,4.706,6.869,4.7s-.29-.03-.446-.036a.856.856,0,0,0-.632.268A2.614,2.614,0,0,0,4.9,6.847a4.535,4.535,0,0,0,.861,2.446,9.56,9.56,0,0,0,3.845,3.669c2.333,1.023,2.345.711,2.773.688A2.357,2.357,0,0,0,14,12.6a1.952,1.952,0,0,0,.177-1.1c-.055-.1-.208-.164-.436-.289M9.459,16.737A7.539,7.539,0,0,1,5.282,15.48l-2.919.936.949-2.824a7.589,7.589,0,1,1,6.147,3.146M9.459,0A9.137,9.137,0,0,0,1.647,13.85L0,18.75l5.05-1.619A9.131,9.131,0,1,0,9.459,0"
                        transform="translate(0 0)"
                        fill="#f1f2f2"
                        stroke="#242222"
                        stroke-width="0.4"
                        fill-rule="evenodd"
                      />
                    </g>
                  </svg>
                </a>
              </div>
              <a
                target="_blank"
                href="mailto:Business@begenerous.com.br"
                class="mail"
                rel="noreferrer"
              >
                Business@begenerous.com.br
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Business;
